import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
  IAllocatorDataProps,
  IMyAllocatorInitialState,
} from 'redux/saga/lenders/Allocator.types';
import { AllocatorListPayload } from 'redux/types/Allocator.types';

import { APIStatus } from '../../../services/api/apiStatusCode';
import { IActionPayload } from '../../types/UserPermission.types';

export const pendingLendersInitialState: IMyAllocatorInitialState = {
  status: APIStatus.INIT,
  lenderData: [],
  isLoading: false,
  error: {},
};

const pendingLenderSlice = createSlice({
  name: 'pendingLenders',
  initialState: pendingLendersInitialState,
  reducers: {
    fetchPendingAllocator: (
      state,
      action: PayloadAction<AllocatorListPayload>
    ) => {
      state.isLoading = true;
      state.status = APIStatus.PENDING;
    },
    fetchPendingAllocatorSucceeded: (
      state: IMyAllocatorInitialState,
      action: PayloadAction<IAllocatorDataProps[]>
    ) => {
      state.lenderData = action.payload;
      state.isLoading = false;
      state.status = APIStatus.SUCCESS;
    },
    fetchPendingAllocatorFailed: (
      state: IMyAllocatorInitialState,
      action: PayloadAction<IActionPayload>
    ) => {
      const { error } = action.payload;
      state.error = error;
      state.isLoading = false;

      state.status = APIStatus.ERROR;
    },
    resetLenderState: () => pendingLendersInitialState,
  },
});

export const {
  fetchPendingAllocator,
  fetchPendingAllocatorSucceeded,
  fetchPendingAllocatorFailed,
  resetLenderState,
} = pendingLenderSlice.actions;

export default pendingLenderSlice.reducer;
